import { Auth } from 'aws-amplify';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Routes } from './config/routes';
import { logout } from './utils/auth';

function App({ initUser }) {
  // const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  // const [isReloading, setIsReloading] = useState(false);
  // const pollingIntervalRef = useRef(null);
  // const latestVersionRef = useRef(null);

  // Detect Cognito LocalStorage Keys
  const hasCognitoTokens = () =>
    Object.keys(localStorage).some(key =>
      key.includes("CognitoIdentityServiceProvider")
    );

  // Fetch meta.json version
  // const getLatestVersion = async () => {
  //   try {
  //     const res = await fetch(`/meta.json?_=${Date.now()}`, { cache: "no-store" });
  //     const data = await res.json();
  //     console.log('🔍 Fetched version from meta.json:', data?.version);
  //     return data?.version || null;
  //   } catch (error) {
  //     console.error('❌ Error fetching version:', error);
  //     return null;
  //   }
  // };

  // Check for version updates - wrapped in useCallback to avoid stale closures
  // const checkForUpdates = useCallback(async () => {
  //   console.log('⏰ Checking for updates...');
  //   const storedVersion = localStorage.getItem("appVersion");
  //   const latestVersion = await getLatestVersion();

  //   console.log('📦 Stored version:', storedVersion);
  //   console.log('🆕 Latest version:', latestVersion);

  //   if (latestVersion && storedVersion && storedVersion !== latestVersion) {
  //     console.log('🚀 New version detected! Showing popup...');
  //     latestVersionRef.current = latestVersion;
  //     setShowUpdatePopup(true);
      
  //     // Stop polling once update is detected
  //     if (pollingIntervalRef.current) {
  //       clearInterval(pollingIntervalRef.current);
  //       pollingIntervalRef.current = null;
  //       console.log('⏹️ Polling stopped');
  //     }
  //   } else {
  //     console.log('✅ Version is up to date');
  //   }
  // }, []); // Empty dependency array since it doesn't depend on any props/state

  // Handle Force Update
  // const handleForceUpdate = async () => {
  //   try {
  //     setIsReloading(true);
  //     console.log('🔄 Starting force update...');

  //     // Use the stored latest version
  //     const versionToSet = latestVersionRef.current || await getLatestVersion();
  //     if (versionToSet) {
  //       localStorage.setItem("appVersion", versionToSet);
  //       console.log('💾 Set new version in localStorage:', versionToSet);
  //     }

  //     localStorage.setItem("updateInProgress", "true");
  //     sessionStorage.clear();

  //     if ("caches" in window) {
  //       const cacheNames = await caches.keys();

  //       for (const cacheName of cacheNames) {
  //         if (cacheName.includes("customer") || cacheName.includes("spirits")) {
  //           const cache = await caches.open(cacheName);
  //           const requests = await cache.keys();

  //           for (const req of requests) {
  //             const url = req.url;
  //             if (
  //               url.includes("/static/js/") ||
  //               url.includes("/static/css/") ||
  //               url.includes("/index.html") ||
  //               url.includes("/asset-manifest.json")
  //             ) {
  //               await cache.delete(req);
  //             }
  //           }
  //         }
  //       }
  //       console.log('🗑️ Cache cleared');
  //     }

  //     console.log('🔃 Reloading page...');
  //     window.location.reload();
  //   } catch (error) {
  //     console.error('❌ Error during update:', error);
  //     window.location.reload();
  //   }
  // };

  // Version + Auth Logic
  useEffect(() => {
    async function init() {
      // console.log('🚀 App initializing...');
      
      // if (localStorage.getItem("updateInProgress") === "true") {
      //   localStorage.removeItem("updateInProgress");
      //   console.log('✅ Update completed, removed flag');
      // }

      // const storedVersion = localStorage.getItem("appVersion");
      // const userHasTokens = hasCognitoTokens();
      // const latestVersion = await getLatestVersion();

      // console.log('Initial check - Stored:', storedVersion, 'Latest:', latestVersion, 'Has tokens:', userHasTokens);

      // // If user has tokens but no stored version, show popup
      // if (userHasTokens && !storedVersion) {
      //   console.log('⚠️ User has tokens but no version - showing popup');
      //   latestVersionRef.current = latestVersion;
      //   setShowUpdatePopup(true);
      //   return;
      // }

      // // If no user and no version, silently set it (new user)
      // if (!userHasTokens && !storedVersion && latestVersion) {
      //   localStorage.setItem("appVersion", latestVersion);
      //   console.log('📝 New user - set initial version:', latestVersion);
      // }

      // // If versions mismatch, show popup but DON'T update localStorage yet
      // if (latestVersion && storedVersion && storedVersion !== latestVersion) {
      //   console.log('🚨 Version mismatch detected - showing popup');
      //   latestVersionRef.current = latestVersion;
      //   setShowUpdatePopup(true);
      //   return;
      // }

      // Auth check
      Auth.currentSession()
        .then((session) => {
          if (!session.isValid()) {
            console.log('❌ Session invalid - logging out');
            logout(() => {});
            return;
          }
          console.log('✅ Session valid - initializing user');
          initUser();
        })
        .catch(() => {
          console.log('❌ Session error - logging out');
          logout(() => {});
        });
    }

    init();
  }, [initUser]);

  // Polling for version updates while user is active
  // useEffect(() => {
  //   console.log('⏰ Starting version polling (every 2 minutes)...');
    
  //   // Check immediately on mount
  //   checkForUpdates();
    
  //   // Then check every 2 minutes
  //   pollingIntervalRef.current = setInterval(() => {
  //     checkForUpdates();
  //   }, 120000); // 2 minutes

  //   // Cleanup on unmount
  //   return () => {
  //     if (pollingIntervalRef.current) {
  //       console.log('🛑 Stopping version polling');
  //       clearInterval(pollingIntervalRef.current);
  //     }
  //   };
  // }, [checkForUpdates]);

  // Check for updates when tab becomes visible
  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === 'visible' && !showUpdatePopup) {
  //       console.log('👀 Tab became visible - checking for updates');
  //       checkForUpdates();
  //     }
  //   };

  //   document.addEventListener('visibilitychange', handleVisibilityChange);

  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, [checkForUpdates, showUpdatePopup]);

  // ------------------------------
  // FINAL POPUP UI
  // ------------------------------
  // const UpdatePopup = () => (
  //   <div style={overlayStyle}>
  //     <div style={transparentPopup}>
        
  //       <h2 style={lightTitle}>🚀 A new version of 1800Spirits is available!</h2>

  //       <p style={lightDesc}>
  //         Please update to continue using the app.
  //       </p>

  //       <button
  //         style={transparentButton}
  //         onClick={handleForceUpdate}
  //         disabled={isReloading}
  //       >
  //         {isReloading ? "Updating..." : "Update Now"}
  //       </button>

  //     </div>
  //   </div>
  // );

  // ------------------------------
  // STYLES
  // ------------------------------

  // const overlayStyle = {
  //   position: "fixed",
  //   inset: 0,
  //   background: "rgba(0, 0, 0, 0.45)",
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   zIndex: 99999,
  // };

  // const transparentPopup = {
  //   textAlign: "center",
  //   color: "#fff",
  //   fontFamily: "system-ui",
  // };

  // const lightTitle = {
  //   fontSize: "20px",
  //   fontWeight: "500",
  //   marginBottom: "10px",
  //   color: "#fff",
  // };

  // const lightDesc = {
  //   fontSize: "15px",
  //   opacity: 0.9,
  //   marginBottom: "20px",
  //   color: "#fff",
  // };

  // const transparentButton = {
  //   padding: "10px 20px",
  //   background: "#b93728",
  //   border: "none",
  //   borderRadius: "8px",
  //   color: "#fff",
  //   fontSize: "14px",
  //   fontWeight: "600",
  //   cursor: "pointer",
  //   transition: "0.2s",
  // };

  return (
    <>
      {/* ⭐ ALWAYS RENDER ROUTES (background visible) */}
      <Routes />

      {/* ⭐ POPUP OVERLAY ON TOP */}
      {/* {showUpdatePopup && <UpdatePopup />} */}

      <ToastContainer />
    </>
  );
}

const stateMapper = () => ({});

const dispatchMapper = (dispatch) => ({
  initUser: dispatch.auth.fetchAndSetUser,
});

export default connect(stateMapper, dispatchMapper)(App);